import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Settings = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7493 7.68333C15.241 7.68333 14.6244 6.61666 15.3744 5.30833C15.8077 4.55 15.5493 3.58333 14.791 3.15L13.3493 2.325C12.691 1.93333 11.841 2.16666 11.4493 2.825L11.3577 2.98333C10.6077 4.29166 9.37435 4.29166 8.61602 2.98333L8.52435 2.825C8.14935 2.16666 7.29935 1.93333 6.64102 2.325L5.19935 3.15C4.44102 3.58333 4.18268 4.55833 4.61602 5.31666C5.37435 6.61666 4.75768 7.68333 3.24935 7.68333C2.38268 7.68333 1.66602 8.39166 1.66602 9.26666V10.7333C1.66602 11.6 2.37435 12.3167 3.24935 12.3167C4.75768 12.3167 5.37435 13.3833 4.61602 14.6917C4.18268 15.45 4.44102 16.4167 5.19935 16.85L6.64102 17.675C7.29935 18.0667 8.14935 17.8333 8.54102 17.175L8.63268 17.0167C9.38268 15.7083 10.616 15.7083 11.3743 17.0167L11.466 17.175C11.8577 17.8333 12.7077 18.0667 13.366 17.675L14.8077 16.85C15.566 16.4167 15.8243 15.4417 15.391 14.6917C14.6327 13.3833 15.2494 12.3167 16.7577 12.3167C17.6244 12.3167 18.341 11.6083 18.341 10.7333V9.26666C18.3327 8.4 17.6243 7.68333 16.7493 7.68333ZM9.99935 12.7083C8.50768 12.7083 7.29102 11.4917 7.29102 10C7.29102 8.50833 8.50768 7.29167 9.99935 7.29167C11.491 7.29167 12.7077 8.50833 12.7077 10C12.7077 11.4917 11.491 12.7083 9.99935 12.7083Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default Settings;
